import type { IProgressPromise, IProgressPromiseGenerator } from '@monofe/util';
import type { IMediaManager } from '../../controller/interface';
import type { IMediumDto } from '../../model';

function _isMedium(object: unknown): object is IMediumDto {
    if (object === null || object === undefined || typeof object !== 'object') {
        return false;
    }
    const record: Partial<IMediumDto> = object as Partial<IMediumDto>;

    /* Force to boolean type */
    return Boolean(record.apply && record.flatten && record.mappings);
}

async function _removeMedia(
    manager: IMediaManager,
    media: (IMediumDto | string)[],
    onProgressCallback: (progress: number) => void,
) {
    const mediaIds = media.map(item => (_isMedium(item) ? item.id : item));
    const progressPerItem = 1 / mediaIds.length;
    for (const [index, mediaId] of mediaIds.entries()) {
        await manager.removeMediumCache(mediaId);
        onProgressCallback(index * progressPerItem);
    }
}

function removeMedia(
    promiser: IProgressPromiseGenerator,
    manager: IMediaManager,
    media: (IMediumDto | string)[],
): IProgressPromise<void> {
    return promiser.promise((resolve, reject, progress) => {
        _removeMedia(manager, media, progress)
            .then(() => {
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
}

export default removeMedia;
